import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiRequest from '../../api/request';
import { formatDataForDataTable } from '../../utils/formatData';

const initialState = {
  loading: false,
  allPolicies: [],
  rootPolicies: [],
  policyTypeUderRoot: [],
  rolesUnderDep: [],
  organizationPolicy: [],
  departmentPolicy: [],
  roleBasedPolicy: [],
  userPolicy: [],
  wings: [],
  roles: [],
};

export const getAllHrPolicies = createAsyncThunk('hrPolicy/getAllHrPolicies', async (rootType) => {
  const res = await apiRequest({
    method: 'get',
    url: `hr-policy/get-all-hr-policy?rootType=${rootType}`,
  });
  return res;
});

export const getRootPolicy = createAsyncThunk('hrPolicy/getRootPolicy', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `hr-policy/get-all-root-policies`,
  });
  return res;
});

export const getPolicyTypesUnderRoot = createAsyncThunk('hrPolicy/getPolicyTypesUnderRoot', async (rootId) => {
  const res = await apiRequest({
    method: 'get',
    url: `hr-policy/get-policy-types-under-root-id/${rootId}`,
  });
  return res;
});

export const getRolesUnderDep = createAsyncThunk('hrPolicy/getRolesUnderDep', async (depId) => {
  const res = await apiRequest({
    method: 'get',
    url: `hr-policy/get-roles-under-department/${depId}`,
  });
  return res;
});
export const fileUpload = createAsyncThunk('hrPolicy/fileUpload', async (file) => {
  const res = await apiRequest({
    method: 'post',
    url: `general/file-upload`,
    data: { uploads: file },
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return res;
});

export const createHrpolicy = createAsyncThunk('hrPolicy/createHrpolicy', async (data) => {
  const res = await apiRequest({
    method: 'post',
    url: `hr-policy/create-policy`,
    data: data,
  });
  return res;
});
export const createHrpolicyType = createAsyncThunk('hrPolicy/createHrpolicyType', async (data) => {
  const res = await apiRequest({
    method: 'post',
    url: `hr-policy/create-hr-policy-type`,
    data: data,
  });
  return res;
});

export const deleteOrInactivePolicy = createAsyncThunk('hrPolicy/deleteOrInactive', async (data) => {
  const res = await apiRequest({
    method: 'patch',
    url: `hr-policy/delete-or-inactive-policy/${data.policyId}/${data.status}`,
  });
  return res;
});

export const getOrganizationPolicy = createAsyncThunk('hrPolicy/getOrganizationPolicy', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `hr-policy/get-organization-policy`,
  });
  return res;
});

export const getDepartmentPolicy = createAsyncThunk('hrPolicy/getDepartmentPolicy', async (depId) => {
  const res = await apiRequest({
    method: 'get',
    url: `hr-policy/get-department-policy/${depId}`,
  });
  return res;
});

export const getRoleBasedPolicy = createAsyncThunk('hrPolicy/getRoleBasedPolicy', async (roleId) => {
  const res = await apiRequest({
    method: 'get',
    url: `hr-policy/get-role-policy/${roleId}`,
  });
  return res;
});

export const getUserPolicy = createAsyncThunk('hrPolicy/getUserPolicy', async (userId) => {
  const res = await apiRequest({
    method: 'get',
    url: `hr-policy/get-user-policy/${userId}`,
  });
  return res;
});
export const getWingsUnderDept = createAsyncThunk('hrPolicy/getWingsUnderDept', async (deptId) => {
  const res = await apiRequest({
    method: 'get',
    url: `hr-policy/get-wings-under-dept?deptId=${deptId}`,
  });
  return res;
});
export const getRolesUnderWing = createAsyncThunk('hrPolicy/getRolesUnderWing', async (wingId) => {
  const res = await apiRequest({
    method: 'get',
    url: `hr-policy/get-roles-under-wing?wing_id=${wingId}`,
  });
  return res;
});
const hrPolicySlice = createSlice({
  name: 'hrPolicySlice',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    //.................getAllHrPolicies..............................
    builder.addCase(getAllHrPolicies.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getAllHrPolicies.fulfilled, (state, action) => {
      return {
        ...state,
        allPolicies: formatDataForDataTable(action.payload?.data),
        loading: false,
      };
    });
    // -------------------getRootPolicy--------------------
    builder.addCase(getRootPolicy.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getRootPolicy.fulfilled, (state, action) => {
      return {
        ...state,
        rootPolicies: action.payload?.data,
        loading: false,
      };
    });
    // ------------------getPolicyTypesUnderRoot--------------------------
    builder.addCase(getPolicyTypesUnderRoot.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getPolicyTypesUnderRoot.fulfilled, (state, action) => {
      return {
        ...state,
        policyTypeUderRoot: action.payload?.data,
        loading: false,
      };
    });
    // ----------------------getRolesUnderDep-----------------------
    builder.addCase(getRolesUnderDep.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getRolesUnderDep.fulfilled, (state, action) => {
      return {
        ...state,
        rolesUnderDep: action.payload?.data,
        loading: false,
      };
    });
    // -------------------fileUpload--------------------------
    builder.addCase(fileUpload.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(fileUpload.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ---------------------createHrpolicy-----------------------------
    builder.addCase(createHrpolicy.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(createHrpolicy.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ----------------------createHrpolicyType-----------------------
    builder.addCase(createHrpolicyType.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(createHrpolicyType.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // -------------------deleteOrInactive------------

    builder.addCase(deleteOrInactivePolicy.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(deleteOrInactivePolicy.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // -----------------getOrganizationPolicy---------------------------
    builder.addCase(getOrganizationPolicy.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getOrganizationPolicy.fulfilled, (state, action) => {
      return {
        ...state,
        organizationPolicy: action.payload.data,
        loading: false,
      };
    });
    // -----------------getDepartmentPolicy------------------
    builder.addCase(getDepartmentPolicy.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getDepartmentPolicy.fulfilled, (state, action) => {
      return {
        ...state,
        departmentPolicy: action.payload.data,
        loading: false,
      };
    });
    // -------------------getRoleBasedPolicy-----------------------

    builder.addCase(getRoleBasedPolicy.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getRoleBasedPolicy.fulfilled, (state, action) => {
      return {
        ...state,
        roleBasedPolicy: action.payload.data,
        loading: false,
      };
    });
    // --------------------getUserPolicy------------------

    builder.addCase(getUserPolicy.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getUserPolicy.fulfilled, (state, action) => {
      return {
        ...state,
        userPolicy: action.payload.data,
        loading: false,
      };
    });
    // ------------------getWingsUnderDept-----------------------

    builder.addCase(getWingsUnderDept.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getWingsUnderDept.fulfilled, (state, action) => {
      return {
        ...state,
        wings: action.payload.data,
        loading: false,
      };
    });
    // --------------getRolesUnderWing------------------------

    builder.addCase(getRolesUnderWing.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getRolesUnderWing.fulfilled, (state, action) => {
      return {
        ...state,
        roles: action.payload.data,
        loading: false,
      };
    });
  },
});

export default hrPolicySlice.reducer;
